import { Box, Button, Card, Heading, Layer, Text } from 'grommet';
import { UnknownAnalyses } from './EditReviewModal';
import { TalonInput } from '../..';

export type MergeDialogModalProps = {
  unknownAnalyses: UnknownAnalyses;
  selectedPerformers: Set<string>;
  processingAction: string | null;
  enlargedFrameUrl?: string;
  mergeName: string;
  setMergeName: (name: string) => void;
  setShowMergeDialog: (show: boolean) => void;
  handleMergePerformers: (editId?: string) => Promise<void>;
};

export const MergeDialogModal = ({
  unknownAnalyses,
  selectedPerformers,
  processingAction,
  mergeName,
  setMergeName,
  setShowMergeDialog,
  handleMergePerformers,
}: MergeDialogModalProps) => {
  /** Render **/
  return (
    <Layer
      onEsc={() => setShowMergeDialog(false)}
      onClickOutside={() => setShowMergeDialog(false)}
      position="center"
      modal={true}
    >
      <Card pad="medium" gap="small" width="medium">
        <Heading level={3} margin="none">
          Merge Selected Performers
        </Heading>
        <Text>
          You are about to merge {selectedPerformers.size} performers into one. This will combine all their frame
          appearances and detected features.
        </Text>

        <Box margin={{ top: 'small' }}>
          <Text weight="bold">Performers to merge:</Text>
          <ul>
            {Array.from(selectedPerformers).map((id) => {
              const analysis = unknownAnalyses.find((a) => a.analysis.performerId === id)?.analysis;
              return (
                <li key={id}>
                  {analysis?.performerName || id} ({analysis?.frameAppears.length || 0} frames)
                </li>
              );
            })}
          </ul>
        </Box>

        <TalonInput
          label="Optional: Give merged performer a name"
          placeholder="e.g., 'Background Extra 1'"
          val={mergeName || ''}
          onChange={(val) => setMergeName(val)}
        />

        <Box direction="row" gap="small" justify="end" margin={{ top: 'small' }}>
          <Button label="Cancel" onClick={() => setShowMergeDialog(false)} />
          <Button
            label="Merge Performers"
            onClick={() => handleMergePerformers()}
            primary
            disabled={processingAction === 'merge'}
          />
        </Box>
      </Card>
    </Layer>
  );
};
